import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRegisterDataIntegrationStepControls } from 'src/features/Signup/hooks/useRegisterDataIntegrationStepControls';
import StartModelingStep from 'src/features/Signup/components/templates/DataIntegrationFlow/steps/StartModelingStep';
import {
  getStepIndex,
  getNextStepPath,
  getPrevStepPath,
} from 'src/features/Signup/utils/dataIntegrationSteps';

const nextPath = getNextStepPath('start-modeling');
const prevPath = getPrevStepPath('start-modeling');

export const StartModelingStepRoute: React.FC = () => {
  const navigate = useNavigate();

  useRegisterDataIntegrationStepControls({
    title: 'Start modeling',
    subtitle: 'Review KPI and marketing data before starting modeling',
    currentStep: getStepIndex('start-modeling'),
    onNext: nextPath ? () => navigate(nextPath) : undefined,
    onBack: prevPath ? () => navigate(prevPath) : undefined,
    isBackDisabled: false,
    isNextDisabled: false,
  });

  return <StartModelingStep />;
};
